module.exports = __webpack_public_path__ + "img/Events-Past seasons.c4054d90.jpg";